// extracted by mini-css-extract-plugin
export default {"happen_bg":"happen_banner_happen_bg__fpw8-","details":"happen_banner_details__pl-TR"};